import { OfferStatus } from '@rd/types';
import { z } from 'zod';

export const offerLocationSchema = z.object({
  name: z.string(),
  address: z.string(),
  city: z.string(),
  country: z.string(),
  email: z.string(),
  phone: z.string(),
  lonlat: z.string(),
  active: z.boolean(),
});

export const howToUseOptionSchema = z.object({
  header: z.string(),
  body: z.string(),
});

export const descriptionOptionSchema = z.object({
  header: z.string(),
  body: z.string(),
});

export const offerTermsSchema = z.object({
  header: z.string(),
  body: z.string(),
});

export const offerEligibleCardsSchema = z.object({
  cardID: z.string(),
  cardLast4Digits: z.string(),
});

export const offerSchema = z.object({
  id: z.string(),
  type: z.string(),
  brand: z.string(),
  title: z.string(),
  categories: z.array(z.string()),
  logoUrl: z.string(),
  coverImageUrl: z.string(),
  eligibleCards: z.array(offerEligibleCardsSchema).nullable(),
  mainCategoryIconUrl: z.string().nullable(),
  shortDescription: z.string().nullable(),
  longDescription: z.union([z.string(), z.array(descriptionOptionSchema)]),
  terms: z.array(offerTermsSchema),
  howToUse: z.union([z.string(), z.array(howToUseOptionSchema)]),
  channels: z.array(z.string()),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  promocode: z.string().nullable(),
  trackingUrlAvailable: z.boolean(),
  website: z.string().nullable(),
  availableUniquePromoCode: z.boolean().optional(),
  useUniquePromoCode: z.boolean().optional(),
  startTime: z.string().nullable(),
  endTime: z.string().nullable(),
  status: z.nativeEnum(OfferStatus),
  active: z.boolean(),
  locations: z.array(offerLocationSchema),
});

export const offerModelSchema = z.object({
  id: z.string(),
  type: z.literal('offer_detailed'),
  attributes: offerSchema.omit({ id: true }),
});

export const offersResponseSchema = z.object({
  data: z.array(offerModelSchema),
});
